import { Fragment } from 'react';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useDispatch } from 'react-redux';

import CircularProgress from '@material-ui/core/CircularProgress';

import ImagesComponent from './ImagesComponent';
import classes from './ShortlistTable.module.css';

import dragHandle from '../../assets/img/dragIcon.svg';
import useAddShortlistedoption from '../../store/contexts/useAddShortlistedoption';
import { reorderShortListData } from '../../utils/utils';

const CostTable = ({ shortlist }) => {
  const { putOption, inProgress } = useAddShortlistedoption();
  const dispatch = useDispatch();

  let shortListCopy = reorderShortListData(shortlist);

  let colSpanVal = 4;
  const customMonths =
    shortListCopy &&
    shortListCopy
      .map((item) => {
        if (item.ratesToInclude && item.ratesToInclude.includes('0')) return item.rateVariableTerm;
      })
      .filter((element) => {
        return element !== null && element != undefined;
      });

  if (customMonths?.length > 0) {
    colSpanVal = 5;
  }

  const dragendHandler = (params) => {
    if (!params.destination || params.destination.index === params.source.index) return;
    const srcI = params.source.index;
    const desI = params.destination.index;

    shortListCopy.splice(desI, 0, shortListCopy.splice(srcI, 1)[0]);

    shortListCopy = shortListCopy.map((obj, index) => ({
      ...obj,
      shortlistedOrder: index + 1,
    }));

    const ids = shortListCopy.map((item) => item.optionId);

    putOption(
      () => {
        dispatch({
          type: 'SET_SHORTLIST_IDS',
          ids: ids,
        });
      },
      'RESET',
      ids,
      shortListCopy,
    );
  };

  return (
    <Fragment>
      <thead>
        <tr>
          <th style={{ minWidth: '40px' }} rowSpan={2}>
            <img src={dragHandle} alt=".." />
          </th>
          <th style={{ minWidth: '250px' }} rowSpan={2}>
            Photos
          </th>
          <th style={{ minWidth: '200px', whiteSpace: 'nowrap' }} rowSpan={2}>
            Name
          </th>
          <th
            colSpan={5}
            style={{
              textAlign: 'center',
              borderBottom: '1px solid rgba(0, 63, 45, 0.15)',
              padding: '5px',
            }}
          >
            Cost per term
          </th>
        </tr>
        <tr style={{ width: '100%', textAlign: 'center', whiteSpace: 'nowrap' }}>
          <th>1 month</th>
          <th>6 months</th>
          <th>12 months</th>
          <th>24 months</th>
          {customMonths?.length > 0 && <th>Custom Month</th>}
        </tr>
      </thead>
      {typeof shortListCopy === 'undefined' && (
        <tbody>
          <tr>
            <td colSpan="8" style={{ textAlign: 'center' }}>
              Nothing is shortlisted
            </td>
          </tr>
        </tbody>
      )}
      <DragDropContext onDragEnd={dragendHandler}>
        <Droppable droppableId="droppale-2">
          {(provided, _) => (
            <tbody ref={provided.innerRef} {...provided.droppableProps}>
              {shortListCopy &&
                shortListCopy.map((item, idx) => (
                  <Draggable key={item.id} draggableId={'draggable2-' + item.id} index={idx}>
                    {(provided, snapshot) => (
                      <tr
                        key={'cost' + item.id}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={{
                          ...provided.draggableProps.style,
                          boxShadow: snapshot.isDragging ? '0 0 0.4rem #666' : '',
                          zIndex: '200',
                        }}
                      >
                        <td
                          style={{ width: '40px', height: '130px' }}
                          {...provided.dragHandleProps}
                        >
                          {<img src={dragHandle} alt=".." />}
                        </td>
                        <td style={{ width: '250px', height: '130px' }}>
                          <ImagesComponent images={item.images} width="200px" height="110px" />
                        </td>
                        <td style={{ width: '150px', height: '130px' }}>{item.optionName}</td>
                        <td style={{ textAlign: 'center', whiteSpace: 'nowrap', width: 'initial' }}>
                          {item.ratesToInclude &&
                          item.ratesToInclude.includes('1') &&
                          item.cost &&
                          item.cost.rateOneMonth
                            ? item.cost.rateOneMonth
                            : ''}
                        </td>
                        <td style={{ textAlign: 'center', whiteSpace: 'nowrap', width: 'reset' }}>
                          {item.ratesToInclude &&
                          item.ratesToInclude.includes('6') &&
                          item.cost &&
                          item.cost.rateSixMonths
                            ? item.cost.rateSixMonths
                            : ''}
                        </td>
                        <td style={{ textAlign: 'center', whiteSpace: 'nowrap', width: 'reset' }}>
                          {item.ratesToInclude &&
                          item.ratesToInclude.includes('12') &&
                          item.cost &&
                          item.cost.rateTwelveMonths
                            ? item.cost.rateTwelveMonths
                            : ''}
                        </td>
                        <td style={{ textAlign: 'center', whiteSpace: 'nowrap', width: 'reset' }}>
                          {item.ratesToInclude &&
                          item.ratesToInclude.includes('24') &&
                          item.cost &&
                          item.cost.ratetwentyfourmonths
                            ? item.cost.ratetwentyfourmonths
                            : ''}
                        </td>
                        {customMonths.length > 0 && (
                          <td style={{ textAlign: 'center', whiteSpace: 'nowrap', width: 'reset' }}>
                            {item.ratesToInclude &&
                            item.ratesToInclude.includes('0') &&
                            item.cost &&
                            item.cost.rateVariable
                              ? item.cost.rateVariable + ' [' + item.rateVariableTerm + '] '
                              : ''}
                          </td>
                        )}
                      </tr>
                    )}
                  </Draggable>
                ))}
            </tbody>
          )}
        </Droppable>
      </DragDropContext>
      {inProgress && (
        <span className={classes.spinner}>
          <CircularProgress color="inherit" />
        </span>
      )}
    </Fragment>
  );
};

export default CostTable;
